var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-details-form default-content" }, [
    _c(
      "div",
      { staticClass: "container-shadow" },
      [
        _c("div", { staticClass: "theme-details-form__inputs-list" }, [
          _c(
            "div",
            {
              staticClass:
                "theme-details-form__account-information details-section"
            },
            [
              _c("h2", { staticClass: "section-title-sm" }, [
                _vm._v(_vm._s(_vm.accountInformationText))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8"
                },
                [
                  _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      name: "languageInput",
                      options: _vm.languages,
                      value: _vm.defaultLanguage,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.language,
                      isRequired: true
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      name: "business_registration",
                      options: _vm.businessRadioOptions,
                      value: _vm.business_form_state,
                      label: _vm.businessLabel,
                      isRequired: true
                    },
                    on: { input: _vm.triggerBusinessForm }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.business_form_state === "1"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 gap-5 my-8 md:grid-cols-2 md:gap-8"
                    },
                    [
                      _vm.website == "staffhousing"
                        ? _c("input", {
                            attrs: {
                              type: "hidden",
                              name: "business_registration",
                              value: "1"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.companyName,
                          name: _vm.companyNameInput,
                          placeholder: _vm.companyNamePlaceholder,
                          isRequired: true
                        },
                        model: {
                          value: _vm.company_value,
                          callback: function($$v) {
                            _vm.company_value = $$v
                          },
                          expression: "company_value"
                        }
                      }),
                      _vm._v(" "),
                      _vm.website == "staffhousing"
                        ? _c(
                            "div",
                            [
                              _c("theme-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "alpha_spaces_dash",
                                    expression: "`alpha_spaces_dash`"
                                  }
                                ],
                                attrs: {
                                  label:
                                    (_vm.locales &&
                                      _vm.locales.subscriptions &&
                                      _vm.locales.subscriptions.contact_person +
                                        " ") + _vm.subscriptionsFirstName,
                                  name: _vm.subscriptionsFirstNameInput,
                                  placeholder:
                                    _vm.subscriptionsFirstNamePlaceholder
                                },
                                model: {
                                  value: _vm.subscriptions_first_name_value,
                                  callback: function($$v) {
                                    _vm.subscriptions_first_name_value = $$v
                                  },
                                  expression: "subscriptions_first_name_value"
                                }
                              }),
                              _vm._v(" "),
                              _c("theme-input", {
                                attrs: {
                                  label:
                                    (_vm.locales &&
                                      _vm.locales.subscriptions &&
                                      _vm.locales.subscriptions.contact_person +
                                        " ") + _vm.subscriptionsMiddleName,
                                  name: _vm.subscriptionsMiddleNameInput,
                                  placeholder:
                                    _vm.subscriptionsMiddleNamePlaceholder
                                },
                                model: {
                                  value: _vm.subscriptions_middle_name_value,
                                  callback: function($$v) {
                                    _vm.subscriptions_middle_name_value = $$v
                                  },
                                  expression: "subscriptions_middle_name_value"
                                }
                              }),
                              _vm._v(" "),
                              _c("theme-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "alpha_spaces_dash",
                                    expression: "`alpha_spaces_dash`"
                                  }
                                ],
                                attrs: {
                                  label:
                                    (_vm.locales &&
                                      _vm.locales.subscriptions &&
                                      _vm.locales.subscriptions.contact_person +
                                        " ") + _vm.subscriptionsLastName,
                                  name: _vm.subscriptionsLastNameInput,
                                  placeholder:
                                    _vm.subscriptionsLastNamePlaceholder
                                },
                                model: {
                                  value: _vm.subscriptions_last_name_value,
                                  callback: function($$v) {
                                    _vm.subscriptions_last_name_value = $$v
                                  },
                                  expression: "subscriptions_last_name_value"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyLegalForm,
                          name: _vm.companyLegalFormInput,
                          placeholder: _vm.companyLegalFormPlaceholder
                        },
                        model: {
                          value: _vm.company_legal_form_value,
                          callback: function($$v) {
                            _vm.company_legal_form_value = $$v
                          },
                          expression: "company_legal_form_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_num_spaces",
                            expression: "`alpha_num_spaces`"
                          }
                        ],
                        attrs: {
                          label: _vm.companyChamberOfCommerceNumber,
                          name: _vm.companyChamberOfCommerceNumberInput,
                          placeholder:
                            _vm.companyChamberOfCommerceNumberPlaceholder
                        },
                        model: {
                          value: _vm.company_chamber_of_commerce_number_value,
                          callback: function($$v) {
                            _vm.company_chamber_of_commerce_number_value = $$v
                          },
                          expression:
                            " company_chamber_of_commerce_number_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_num_spaces",
                            expression: "`alpha_num_spaces`"
                          }
                        ],
                        attrs: {
                          label: _vm.companyVatNumber,
                          name: _vm.companyVatNumberInput,
                          placeholder: _vm.companyVatNumberPlaceholder
                        },
                        model: {
                          value: _vm.companyVatNumberValue,
                          callback: function($$v) {
                            _vm.companyVatNumberValue = $$v
                          },
                          expression: "companyVatNumberValue"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyPostCode,
                          placeholder: _vm.companyPostCodePlaceholder,
                          name: _vm.companyPostCodeInput
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkPcHnCompany($event)
                          }
                        },
                        model: {
                          value: _vm.company_post_code_value,
                          callback: function($$v) {
                            _vm.company_post_code_value = $$v
                          },
                          expression: "company_post_code_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyHouseNumber,
                          placeholder: _vm.companyHouseNumberPlaceholder,
                          name: _vm.companyHouseNumberInput
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkPostcodeAddressCompany($event)
                          }
                        },
                        model: {
                          value: _vm.company_house_number_value,
                          callback: function($$v) {
                            _vm.company_house_number_value = $$v
                          },
                          expression: "company_house_number_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyStreet,
                          name: _vm.companyStreetInput,
                          placeholder: _vm.companyStreetPlaceholder
                        },
                        model: {
                          value: _vm.company_street_value,
                          callback: function($$v) {
                            _vm.company_street_value = $$v
                          },
                          expression: "company_street_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyCity,
                          name: _vm.companyCityInput,
                          placeholder: _vm.companyCityPlaceholder
                        },
                        model: {
                          value: _vm.company_city_value,
                          callback: function($$v) {
                            _vm.company_city_value = $$v
                          },
                          expression: "company_city_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyCountry,
                          name: _vm.companyCountryInput,
                          placeholder: _vm.companyCountryPlaceholder
                        },
                        model: {
                          value: _vm.company_country_value,
                          callback: function($$v) {
                            _vm.company_country_value = $$v
                          },
                          expression: "company_country_value"
                        }
                      }),
                      _vm._v(" "),
                      _vm.website == "staffhousing"
                        ? _c("theme-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|phone_number",
                                expression: "`required|phone_number`"
                              }
                            ],
                            attrs: {
                              label: _vm.companyPhoneNumber,
                              placeholder: _vm.companyPhoneNumberPlaceholder,
                              name: _vm.companyPhoneNumberInput
                            },
                            model: {
                              value: _vm.company_phone_number_value,
                              callback: function($$v) {
                                _vm.company_phone_number_value = $$v
                              },
                              expression: "company_phone_number_value"
                            }
                          })
                        : _c("theme-input", {
                            attrs: {
                              label: _vm.companyPhoneNumber,
                              placeholder: _vm.companyPhoneNumberPlaceholder,
                              name: _vm.companyPhoneNumberInput
                            },
                            model: {
                              value: _vm.company_phone_number_value,
                              callback: function($$v) {
                                _vm.company_phone_number_value = $$v
                              },
                              expression: "company_phone_number_value"
                            }
                          }),
                      _vm._v(" "),
                      _vm.website == "staffhousing"
                        ? _c("theme-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "`required|email`"
                              }
                            ],
                            attrs: {
                              label: _vm.companyEmail,
                              placeholder: _vm.companyEmailPlaceholder,
                              name: _vm.companyEmailInput
                            },
                            model: {
                              value: _vm.company_email_value,
                              callback: function($$v) {
                                _vm.company_email_value = $$v
                              },
                              expression: "company_email_value"
                            }
                          })
                        : _c("theme-input", {
                            attrs: {
                              label: _vm.companyEmail,
                              placeholder: _vm.companyEmailPlaceholder,
                              name: _vm.companyEmailInput
                            },
                            model: {
                              value: _vm.company_email_value,
                              callback: function($$v) {
                                _vm.company_email_value = $$v
                              },
                              expression: "company_email_value"
                            }
                          }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyBankAccount,
                          placeholder: _vm.companyBankAccountPlaceholder,
                          name: _vm.companyBankAccountInput
                        },
                        model: {
                          value: _vm.company_bank_account_value,
                          callback: function($$v) {
                            _vm.company_bank_account_value = $$v
                          },
                          expression: "company_bank_account_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyBic,
                          placeholder: _vm.companyBicPlaceholder,
                          name: _vm.companyBicInput
                        },
                        model: {
                          value: _vm.company_bic_value,
                          callback: function($$v) {
                            _vm.company_bic_value = $$v
                          },
                          expression: "company_bic_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        attrs: {
                          label: _vm.companyInvoiceEmail,
                          placeholder: _vm.companyInvoiceEmailPlaceholder,
                          name: _vm.companyInvoiceEmailInput
                        },
                        model: {
                          value: _vm.companyInvoiceEmailValue,
                          callback: function($$v) {
                            _vm.companyInvoiceEmailValue = $$v
                          },
                          expression: "companyInvoiceEmailValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "theme-details-form__income details-section" },
            [
              _c("h2", { staticClass: "section-title-xs" }, [
                _vm._v(_vm._s(_vm.subscriptionsIncome))
              ]),
              _vm._v(" "),
              _c("theme-checkboxes", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|make_choice",
                    expression: "`required|make_choice`"
                  }
                ],
                attrs: {
                  label: _vm.subscriptionsIAm,
                  name: _vm.subscriptionsTypeOfIncomeInput,
                  options: _vm.subscriptionsTypeOfIncomeOptions,
                  values: _vm.subscriptionsTypeOfIncomeValue
                },
                on: { input: _vm.triggerIncomeAdditionalForms }
              }),
              _vm._v(" "),
              _vm.income_form_work_business
                ? _c(
                    "div",
                    [
                      _vm.income_form_work
                        ? _c("theme-radios", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|make_choice",
                                expression: "`required|make_choice`"
                              }
                            ],
                            staticClass: "mb-8",
                            attrs: {
                              label: _vm.usersContractTypeLabel,
                              name: _vm.usersContractTypeInput,
                              options: _vm.usersContractTypeOptions,
                              value: _vm.usersContractTypeValue,
                              isRequired: true,
                              columnDirection: true
                            },
                            on: { input: _vm.triggerContractDuration }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDuration && _vm.income_form_work
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "grid grid-cols-1 gap-5 mb-6 md:grid-cols-2 md:gap-8 md:mb-8"
                            },
                            [
                              _c("theme-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|numeric",
                                    expression: "`required|numeric`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersContractDuration,
                                  name: _vm.usersContractDurationInput,
                                  placeholder:
                                    _vm.usersContractDurationPlaceholder,
                                  value: _vm.usersContractDurationValue,
                                  isRequired: true
                                }
                              }),
                              _vm._v(" "),
                              _c("functional-calendar", {
                                staticClass:
                                  "single-calendar min-w-[250px] md:w-full",
                                attrs: { configs: _vm.calendarConfigs },
                                on: { choseDay: _vm.changeContractEndDate },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "datePickerInput",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "theme-input",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "`required`"
                                                }
                                              ],
                                              attrs: {
                                                label: _vm.usersContractEndDate,
                                                value:
                                                  _vm.contractEndDateComputed,
                                                name:
                                                  _vm.usersContractEndDateInput,
                                                isExtraInfo: true,
                                                isReadonly: true,
                                                placeholder:
                                                  _vm.usersContractEndDatePlaceholder,
                                                isRequired: true
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "extra-info" },
                                                [
                                                  _c("i", {
                                                    staticClass: "icon-calendar"
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            attrs: {
                                              type: "hidden",
                                              name:
                                                _vm.usersContractEndDateInput
                                            },
                                            domProps: {
                                              value: _vm.hiddenContractEndDate
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619233674
                                ),
                                model: {
                                  value: _vm.contractEndDate,
                                  callback: function($$v) {
                                    _vm.contractEndDate = $$v
                                  },
                                  expression: "contractEndDate"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8"
                        },
                        [
                          _c(
                            "theme-input",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "`required|numeric`"
                                }
                              ],
                              attrs: {
                                label: _vm.usersMonthlyIncome,
                                name: _vm.usersMonthlyIncomeInput,
                                placeholder: _vm.usersMonthlyIncomePlaceholder,
                                isRequired: true,
                                isExtraInfo: true,
                                isExtraNote: true
                              },
                              model: {
                                value: _vm.users_monthly_income_value,
                                callback: function($$v) {
                                  _vm.users_monthly_income_value = $$v
                                },
                                expression: "users_monthly_income_value"
                              }
                            },
                            [
                              _c("template", { slot: "extra-info" }, [
                                _vm._v("\n                €\n              ")
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "extra-note" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.usersMonthlyIncomeNote) +
                                    "\n              "
                                )
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("theme-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersOccupation,
                              name: _vm.usersOccupationInput,
                              placeholder: _vm.usersOccupationPlaceholder,
                              isRequired: true
                            },
                            model: {
                              value: _vm.users_occupation_value,
                              callback: function($$v) {
                                _vm.users_occupation_value = $$v
                              },
                              expression: "users_occupation_value"
                            }
                          }),
                          _vm._v(" "),
                          _c("theme-radios", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "make_choice",
                                expression: "`make_choice`"
                              }
                            ],
                            staticClass: "md:mb-8",
                            attrs: {
                              label: _vm.usersDoYouHaveGuarantorGeneral,
                              name: _vm.usersDoYouHaveGuarantorInput,
                              options: _vm.usersDoYouHaveGuarantorOptions,
                              value: _vm.usersDoYouHaveGuarantorValue
                            },
                            on: { input: _vm.triggerGuarantorForm }
                          }),
                          _vm._v(" "),
                          _vm.guarantor_form_state == 1
                            ? _c("theme-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "`numeric`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersGuarantorIncome,
                                  placeholder:
                                    _vm.usersGuarantorIncomePlaceholder,
                                  name: _vm.usersGuarantorIncomeInput
                                },
                                model: {
                                  value: _vm.users_guarantor_income_value,
                                  callback: function($$v) {
                                    _vm.users_guarantor_income_value = $$v
                                  },
                                  expression: "users_guarantor_income_value"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.income_form_studying
                ? _c(
                    "div",
                    [
                      !_vm.income_form_work_business
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "grid grid-cols-2 gap-5 mb-6 md:gap-8 md:mb-8"
                            },
                            [
                              !_vm.income_form_work_business
                                ? _c("theme-radios", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "make_choice",
                                        expression: "`make_choice`"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.usersDoYouHaveGuarantorGeneral,
                                      name: _vm.usersDoYouHaveGuarantorInput,
                                      options:
                                        _vm.usersDoYouHaveGuarantorOptions,
                                      value: _vm.usersDoYouHaveGuarantorValue
                                    },
                                    on: { input: _vm.triggerGuarantorForm }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.guarantor_form_state == 1
                                ? _c("theme-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|numeric",
                                        expression: "`required|numeric`"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.usersGuarantorIncome,
                                      placeholder:
                                        _vm.usersGuarantorIncomePlaceholder,
                                      name: _vm.usersGuarantorIncomeInput
                                    },
                                    model: {
                                      value: _vm.users_guarantor_income_value,
                                      callback: function($$v) {
                                        _vm.users_guarantor_income_value = $$v
                                      },
                                      expression: "users_guarantor_income_value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        staticClass: "mb-8",
                        attrs: {
                          label: _vm.usersStudy,
                          name: _vm.usersStudyInput,
                          isRequired: true,
                          placeholder: _vm.usersStudyPlaceholder
                        },
                        model: {
                          value: _vm.users_study_value,
                          callback: function($$v) {
                            _vm.users_study_value = $$v
                          },
                          expression: "users_study_value"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.income_form_any
                ? _c("theme-textarea", {
                    attrs: {
                      label: _vm.usersExtraInformationIncome,
                      name: _vm.usersExtraInformationIncomeInput,
                      placeholder: _vm.usersExtraInformationIncomePlaceholder
                    },
                    model: {
                      value: _vm.users_income_note,
                      callback: function($$v) {
                        _vm.users_income_note = $$v
                      },
                      expression: "users_income_note"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "theme-details-form__living-situation details-section"
            },
            [
              _c("h2", { staticClass: "section-title-xs" }, [
                _vm._v(_vm._s(_vm.usersLandlordLabel))
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  name: _vm.usersLandlordRadio,
                  options: _vm.usersLandlordOptions,
                  columnDirection: true
                },
                on: { input: _vm.triggerLandlordType },
                model: {
                  value: _vm.landlord_type_state,
                  callback: function($$v) {
                    _vm.landlord_type_state = $$v
                  },
                  expression: "landlord_type_state"
                }
              }),
              _vm._v(" "),
              _vm.landlord_type_state == "renting_property"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                    },
                    [
                      _c("theme-input", {
                        attrs: {
                          label: _vm.usersLandlordNameLabel,
                          name: _vm.usersLandlordName,
                          placeholder: _vm.usersLandlordNamePlaceholder
                        },
                        model: {
                          value: _vm.users_landlord_name_value,
                          callback: function($$v) {
                            _vm.users_landlord_name_value = $$v
                          },
                          expression: "users_landlord_name_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "email",
                            expression: "`email`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersLandlordEmailLabel,
                          name: _vm.usersLandlordEmail,
                          placeholder: _vm.usersLandlordEmailPlaceholder
                        },
                        model: {
                          value: _vm.users_landlord_email_value,
                          callback: function($$v) {
                            _vm.users_landlord_email_value = $$v
                          },
                          expression: "users_landlord_email_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "phone_number",
                            expression: "`phone_number`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersLandlordPhoneLabel,
                          name: _vm.usersLandlordPhone,
                          placeholder: _vm.usersLandlordPhonePlaceholder
                        },
                        model: {
                          value: _vm.users_landlord_phone_number_value,
                          callback: function($$v) {
                            _vm.users_landlord_phone_number_value = $$v
                          },
                          expression: "users_landlord_phone_number_value"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "theme-details-form__details details-section" },
            [
              _c("h2", { staticClass: "section-title-xs" }, [
                _vm._v(_vm._s(_vm.subscriptionsYourDetails))
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|make_choice",
                    expression: "`required|make_choice`"
                  }
                ],
                attrs: {
                  name: _vm.subscriptionsSexInput,
                  options: _vm.subscriptionsSexOptions,
                  value: _vm.subscriptionsSexValue
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _c("theme-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces_dash",
                        expression: "`required|alpha_spaces_dash`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsFirstName,
                      name: _vm.subscriptionsFirstNameInput,
                      isRequired: _vm.websiteId != 2 ? true : false,
                      placeholder: _vm.subscriptionsFirstNamePlaceholder
                    },
                    model: {
                      value: _vm.subscriptions_first_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_first_name_value = $$v
                      },
                      expression: "subscriptions_first_name_value"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    attrs: {
                      label: _vm.subscriptionsMiddleName,
                      name: _vm.subscriptionsMiddleNameInput,
                      placeholder: _vm.subscriptionsMiddleNamePlaceholder
                    },
                    model: {
                      value: _vm.subscriptions_middle_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_middle_name_value = $$v
                      },
                      expression: "subscriptions_middle_name_value"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces_dash",
                        expression: "`required|alpha_spaces_dash`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsLastName,
                      name: _vm.subscriptionsLastNameInput,
                      placeholder: _vm.subscriptionsLastNamePlaceholder,
                      isRequired: _vm.websiteId != 2 ? true : false
                    },
                    model: {
                      value: _vm.subscriptions_last_name_value,
                      callback: function($$v) {
                        _vm.subscriptions_last_name_value = $$v
                      },
                      expression: "subscriptions_last_name_value"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|phone_number",
                            expression: "`required|phone_number`"
                          }
                        ],
                        staticClass: "js-unique-phone",
                        attrs: {
                          label: _vm.subscriptionsPhoneNumber,
                          name: _vm.subscriptionsPhoneNumberInput,
                          isRequired: true
                        },
                        on: { blur: _vm.checkPhone },
                        model: {
                          value: _vm.subscriptions_phone_number_value,
                          callback: function($$v) {
                            _vm.subscriptions_phone_number_value = $$v
                          },
                          expression: "subscriptions_phone_number_value"
                        }
                      }),
                      _vm._v(" "),
                      !!_vm.is_phone_number_unique
                        ? _c("div", [
                            _c("label"),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "text-red-600 font-semibold" },
                              [_vm._v(_vm._s(_vm.phoneNumberAlreadyExists))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "`required`"
                                }
                              ],
                              attrs: {
                                type: "hidden",
                                name: "phone_number_unique"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "`required|email`"
                          }
                        ],
                        staticClass: "js-unique-mail",
                        attrs: {
                          label: _vm.subscriptionsEmail,
                          name: _vm.subscriptionsEmailInput,
                          placeholder: _vm.subscriptionsEmailPlaceholder,
                          type: "email",
                          isRequired: true
                        },
                        on: { blur: _vm.checkMail },
                        model: {
                          value: _vm.subscriptions_email_value,
                          callback: function($$v) {
                            _vm.subscriptions_email_value = $$v
                          },
                          expression: "subscriptions_email_value"
                        }
                      }),
                      _vm._v(" "),
                      _vm.is_user_already_exists == 1
                        ? _c("div", [
                            _c("label"),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "text-ted-600 font-semibold" },
                              [_vm._v(_vm._s(_vm.isUserAlreadyExists))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "`required`"
                                }
                              ],
                              attrs: {
                                type: "hidden",
                                name: "user_already_exists"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("functional-calendar", {
                    staticClass: "single-calendar min-w-[250px] md:w-full",
                    attrs: { configs: _vm.calendarConfigs },
                    on: { choseDay: _vm.changeBirthDate },
                    scopedSlots: _vm._u([
                      {
                        key: "datePickerInput",
                        fn: function(props) {
                          return [
                            _c(
                              "theme-input",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "`required`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.subscriptionsDateOfBirth,
                                  value: _vm.birthDateComputed,
                                  name: _vm.subscriptionsDateOfBirthInput,
                                  isExtraInfo: true,
                                  isReadonly: true,
                                  placeholder:
                                    _vm.subscriptionsDateOfBirthPlaceholder
                                }
                              },
                              [
                                _c("template", { slot: "extra-info" }, [
                                  _c("i", { staticClass: "icon-calendar" })
                                ])
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.birthDate,
                      callback: function($$v) {
                        _vm.birthDate = $$v
                      },
                      expression: "birthDate"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "email",
                        expression: "`email`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsInvoiceEmail,
                      name: _vm.subscriptionsInvoiceEmailInput,
                      placeholder: _vm.subscriptionsInvoiceEmailPlaceholder,
                      type: "email"
                    },
                    model: {
                      value: _vm.subscriptions_invoice_email_value,
                      callback: function($$v) {
                        _vm.subscriptions_invoice_email_value = $$v
                      },
                      expression: "subscriptions_invoice_email_value"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    attrs: {
                      label: _vm.subscriptionsBankAccount,
                      placeholder: _vm.subscriptionsBankAccountPlaceholder,
                      name: _vm.subscriptionsBankAccountInput
                    },
                    model: {
                      value: _vm.subscriptions_bank_account_value,
                      callback: function($$v) {
                        _vm.subscriptions_bank_account_value = $$v
                      },
                      expression: "subscriptions_bank_account_value"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    attrs: {
                      label: _vm.subscriptionsBic,
                      placeholder: _vm.subscriptionsBicPlaceholder,
                      name: _vm.subscriptionsBicInput
                    },
                    model: {
                      value: _vm.subscriptions_bic_value,
                      callback: function($$v) {
                        _vm.subscriptions_bic_value = $$v
                      },
                      expression: "subscriptions_bic_value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "theme-details-form__address details-section" },
            [
              _c("h2", { staticClass: "section-title-xs" }, [
                _vm._v("Your address")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _c("theme-input", {
                    staticClass: "js-postcode",
                    attrs: {
                      name: _vm.subscriptionsPostCode,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.post_code,
                      placeholder: _vm.subscriptionsPostCodePlaceholder
                    },
                    on: {
                      blur: function($event) {
                        return _vm.checkPcHn($event)
                      }
                    },
                    model: {
                      value: _vm.subscriptions_post_code_value,
                      callback: function($$v) {
                        _vm.subscriptions_post_code_value = $$v
                      },
                      expression: "subscriptions_post_code_value"
                    }
                  }),
                  _vm._v(" "),
                  _c("theme-input", {
                    attrs: {
                      name: _vm.subscriptionsCity,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.city,
                      placeholder: _vm.subscriptionsCityPlaceholder
                    },
                    model: {
                      value: _vm.subscriptions_city_value,
                      callback: function($$v) {
                        _vm.subscriptions_city_value = $$v
                      },
                      expression: "subscriptions_city_value"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _c("theme-input", {
                    staticClass: "col-span-1 stretch-height",
                    attrs: {
                      name: _vm.subscriptionsStreet,
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.street,
                      placeholder: _vm.subscriptionsStreetPlaceholder
                    },
                    model: {
                      value: _vm.subscriptions_street_value,
                      callback: function($$v) {
                        _vm.subscriptions_street_value = $$v
                      },
                      expression: "subscriptions_street_value"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-span-1 md:col-span-2 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                    },
                    [
                      _c("theme-input", {
                        staticClass: "js-house-number stretch-height",
                        attrs: {
                          name: _vm.subscriptionsHouseNumber,
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.house_number,
                          placeholder: _vm.subscriptionsHouseNumberPlaceholder
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkPostcodeAddress($event)
                          }
                        },
                        model: {
                          value: _vm.subscriptions_house_number_value,
                          callback: function($$v) {
                            _vm.subscriptions_house_number_value = $$v
                          },
                          expression: "subscriptions_house_number_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-input", {
                        staticClass: "stretch-height",
                        attrs: {
                          name: _vm.subscriptionsHouseNumberAppendix,
                          label: _vm.subscriptionsHouseNumberAppendixLabel,
                          placeholder:
                            _vm.subscriptionsHouseNumberAppendixPlaceholder
                        },
                        model: {
                          value: _vm.subscriptionsHouseNumberAppendixValue,
                          callback: function($$v) {
                            _vm.subscriptionsHouseNumberAppendixValue = $$v
                          },
                          expression: "subscriptionsHouseNumberAppendixValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "theme-details-form__family-status details-section"
            },
            [
              _c("h2", { staticClass: "section-title-xs" }, [
                _vm._v(
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.subscription &&
                      _vm.locales.subscription.family_status
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-span-1" },
                    [
                      _c("theme-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.subscriptionsCivilState,
                          value: _vm.subscriptionsCivilStateValue,
                          name: _vm.subscriptionsCivilStateInput,
                          options: _vm.subscriptionsCivilStateOptions
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-span-1 md:col-span-2 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                    },
                    [
                      _c("theme-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.subscriptionNumberOfAdults,
                          name: "number_of_adults",
                          options: {
                            "1": "1",
                            "2": "2",
                            "3": "3",
                            "4": "4",
                            "5": "5"
                          }
                        },
                        model: {
                          value: _vm.number_of_adults_value,
                          callback: function($$v) {
                            _vm.number_of_adults_value = _vm._n($$v)
                          },
                          expression: "number_of_adults_value"
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-select", {
                        attrs: {
                          label: _vm.subscriptionsChildren,
                          value: _vm.subscriptions_children_value,
                          name: "have_children",
                          options: _vm.subscriptionsChildrenOptions,
                          "show-zero-option": "0"
                        },
                        on: { input: _vm.triggerChildrenForm }
                      }),
                      _vm._v(" "),
                      _c("theme-select", {
                        attrs: {
                          label: _vm.subscriptionsPets,
                          value: _vm.subscriptions_pets_value,
                          name: "have_pets",
                          options: _vm.subscriptionsPetsOptions,
                          "show-zero-option": "0"
                        },
                        on: { input: _vm.triggerPetsForm }
                      }),
                      _vm._v(" "),
                      _vm.subscriptions_children_value == 1
                        ? _c("theme-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            staticClass: "col-start-2",
                            attrs: {
                              label: _vm.subscriptionsNumberOfChildren,
                              placeholder:
                                _vm.subscriptionsNumberOfChildrenPlaceholder,
                              name: "number_of_children",
                              type: "number",
                              isRequired: true
                            },
                            model: {
                              value: _vm.subscriptions_number_of_children_value,
                              callback: function($$v) {
                                _vm.subscriptions_number_of_children_value = $$v
                              },
                              expression:
                                "subscriptions_number_of_children_value"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.subscriptions_pets_value == 1
                        ? _c("theme-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            staticClass: "col-start-3",
                            attrs: {
                              label: _vm.subscriptionsPetsNote,
                              placeholder: _vm.subscriptionsPetsNotePlaceholder,
                              name: "pets_note",
                              isRequired: true
                            },
                            model: {
                              value: _vm.subscriptions_pets_note_value,
                              callback: function($$v) {
                                _vm.subscriptions_pets_note_value = $$v
                              },
                              expression: "subscriptions_pets_note_value"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("theme-toggler", {
          staticClass: "mb-8",
          attrs: {
            value: _vm.subscriptionsSmokingValue,
            label: _vm.subscriptionsSmoking,
            name: "smoking"
          }
        }),
        _vm._v(" "),
        _vm._l(_vm.number_of_adults_value_computed - 1, function(adult) {
          return _vm.number_of_adults_value > 1 &&
            _vm.website !== "staffhousing"
            ? _c(
                "div",
                { key: adult },
                [
                  _c("theme-details-inner-form", {
                    attrs: {
                      i: adult - 1,
                      "extra-tenants": _vm.extraTenants,
                      subscriptions: _vm.innerFormSubscriptions,
                      "users-title-options": _vm.innerFormUsersTitleOptions,
                      "users-first-name": _vm.subscriptionsFirstName,
                      "users-middle-name": _vm.subscriptionsMiddleName,
                      "users-last-name": _vm.subscriptionsLastName,
                      "users-date-of-birth": _vm.subscriptionsDateOfBirth,
                      "users-phone-number": _vm.subscriptionsPhoneNumber,
                      "users-email": _vm.subscriptionsEmail,
                      "users-invoice-email": _vm.subscriptionsInvoiceEmail,
                      "users-bank-account": _vm.subscriptionsBankAccount,
                      "users-bic": _vm.subscriptionsBic,
                      "users-civil-state": _vm.subscriptionsCivilState,
                      "users-civil-state-options":
                        _vm.subscriptionsCivilStateOptions,
                      "users-type-of-income-options":
                        _vm.subscriptionsTypeOfIncomeOptions,
                      "users-type-of-income-slugs":
                        _vm.subscriptionsTypeOfIncomeSlugs,
                      "users-contract-type": _vm.usersContractTypeLabel,
                      "users-contract-type-options":
                        _vm.usersContractTypeOptions,
                      "users-contract-type-attributes":
                        _vm.usersContractTypeAttributes,
                      "users-contract-duration": _vm.usersContractDuration,
                      "users-contract-end-date": _vm.usersContractEndDate,
                      "users-occupation": _vm.usersOccupation,
                      "users-monthly-income": _vm.usersMonthlyIncome,
                      "users-monthly-income-note": _vm.usersMonthlyIncomeNote,
                      "users-do-you-have-guarantor-general":
                        _vm.usersDoYouHaveGuarantorGeneral,
                      "users-do-you-have-guarantor-options":
                        _vm.usersDoYouHaveGuarantorOptions,
                      "users-guarantor-income": _vm.usersGuarantorIncome,
                      "users-study": _vm.usersStudy,
                      "users-extra-information-income":
                        _vm.usersExtraInformationIncome,
                      "income-form-all-states": _vm.incomeFormAllStates,
                      "income-title": _vm.subscriptionsIncome,
                      "users-landlord-options": _vm.usersLandlordOptions,
                      "is-user-already-exists": _vm.isUserAlreadyExists,
                      "is-user-banned": _vm.isUserBanned,
                      "income-phone-number-already-exists":
                        _vm.phoneNumberAlreadyExists,
                      languages: _vm.languages,
                      "details-title": _vm.subscriptionsDetails,
                      "address-title": _vm.subscriptionsAddress,
                      "family-status-title": _vm.subscriptionsFamilyStatus,
                      "users-house-number-appendix":
                        _vm.subscriptionsHouseNumberAppendix,
                      "users-house-number-appendix-label":
                        _vm.subscriptionsHouseNumberAppendixLabel,
                      "users-house-number-appendix-placeholder":
                        _vm.subscriptionsHouseNumberPlaceholder,
                      "users-house-number-appendix-value":
                        _vm.subscriptionsHouseNumberAppendixValue,
                      "users-house-number-appendix-extra":
                        _vm.subscriptionsHouseNumberAppendixExtra,
                      "users-house-number-appendix-extra-label":
                        _vm.subscriptionsHouseNumberAppendixExtraLabel,
                      "users-house-number-appendix-extra-placeholder":
                        _vm.subscriptionsHouseNumberAppendixExtraPlaceholder,
                      "users-house-number-appendix-extra-value":
                        _vm.subscriptionsHouseNumberAppendixExtraValue,
                      "users-landlord-label": _vm.usersLandlordLabel,
                      "users-first-name-placeholder":
                        _vm.subscriptionsFirstNamePlaceholder,
                      "users-middle-name-placeholder":
                        _vm.subscriptionsMiddleNamePlaceholder,
                      "users-last-name-placeholder":
                        _vm.subscriptionsLastNamePlaceholder,
                      "users-phone-number-placeholder":
                        _vm.subscriptionsPhoneNumberPlaceholder,
                      "users-email-placeholder":
                        _vm.subscriptionsEmailPlaceholder,
                      "users-birth-placeholder":
                        _vm.subscriptionsDateOfBirthPlaceholder,
                      "users-invoice-email-placeholder":
                        _vm.subscriptionsInvoiceEmailPlaceholder,
                      "users-bank-account-placeholder":
                        _vm.subscriptionsBankAccountPlaceholder,
                      "users-bic-placeholder": _vm.subscriptionsBicPlaceholder,
                      "users-post-code-placeholder":
                        _vm.subscriptionsPostCodePlaceholder,
                      "users-city-placeholder":
                        _vm.subscriptionsCityPlaceholder,
                      "users-street-placeholder":
                        _vm.subscriptionsStreetPlaceholder,
                      "users-contract-duration-placeholder":
                        _vm.usersContractDurationPlaceholder,
                      "users-contract-end-date-placeholder":
                        _vm.usersContractEndDatePlaceholder,
                      "users-occupation-placeholder":
                        _vm.usersOccupationPlaceholder,
                      "users-monthly-income-placeholder":
                        _vm.usersMonthlyIncomePlaceholder,
                      "users-guarantor-income-placeholder":
                        _vm.usersGuarantorIncomePlaceholder,
                      "users-study-placeholder": _vm.usersStudyPlaceholder,
                      "users-extra-information-income-placeholder":
                        _vm.usersExtraInformationIncomePlaceholder,
                      "users-landlord-name-placeholder":
                        _vm.usersLandlordNamePlaceholder,
                      "users-landlord-phone-placeholder":
                        _vm.usersLandlordPhonePlaceholder,
                      "users-landlord-email-placeholder":
                        _vm.usersLandlordEmailPlaceholder,
                      "users-house-number-placeholder":
                        _vm.subscriptionsHouseNumberPlaceholder
                    }
                  })
                ],
                1
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm.website !== "staffhousing"
          ? _c(
              "div",
              [
                _c("input", {
                  attrs: { name: "is_newsletter_subscriber", type: "hidden" }
                }),
                _vm._v(" "),
                _c("theme-checkboxes", {
                  staticClass: "theme-details-form__reverted-checkbox",
                  attrs: {
                    label: _vm.subscribeToNewsletter,
                    name: "is_newsletter_subscriber",
                    options: { "1": "" },
                    value: _vm.isNewsletterSubscriberChecked,
                    checked: _vm.isNewsletterSubscriberChecked
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "theme-btn theme-btn--theme w-full md:w-auto",
            attrs: { type: "submit" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(_vm.commonSend) + "\n    ")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c246888", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c246888","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeDetailsForm.vue
// module id = 747
// module chunks = 1